import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

import { Icon } from '../Icon';
import { Typography } from '../Typography';

export const Wrapper = styled(Box)`
  width: 100%;
  align-items: center;
  position: relative;
  ${({
    theme: {
      components: {
        footer: { background },
      },
    },
  }) => css`
    background: ${background};
  `}
  a {
    display: block;
    text-decoration: none;
  }
`;

export const FooterBox = styled(Box)`
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

export const InnerWrapper = styled(Box)`
  width: 100%;
  ${({
    theme: {
      components: {
        footer: { breakpoint, innerWrapper },
      },
    },
  }) => css`
    padding: ${innerWrapper.padding};
    max-width: ${innerWrapper.maxWidth};
    @media (max-width: ${breakpoint}) {
      padding: ${innerWrapper.paddingMobile};
    }
  `}
`;

export const Break = styled(Box)`
  ${({ theme: { colors, components } }) => css`
    width: 100%;
    height: 0px;
    border: 1px solid ${colors.white};
    opacity: 0.1;
    margin: ${components.footer.break.margin};
  `}
  display: block;
  ${({ theme }) => css`
    @media (max-width: ${theme.components.footer.breakpoint}) {
      display: none;
      margin: ${theme.components.footer.break.marginMobile};
    }
  `}
`;

export const ContactInfoWrapper = styled(Box)`
  position: relative;
  margin-bottom: 3rem;
  /* Stack layout at 1440px for newsletter + contact info, before full tablet mode */
  @media (max-width: 90rem) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  ${({
    theme: {
      components: {
        footer: { breakpoint },
      },
    },
  }) => css`
    @media (max-width: ${breakpoint}) {
      text-align: center;
      padding: 32px 16px;
      margin-bottom: 0;
    }
  `}
`;

export const Subscribe = styled(Box)`
  position: absolute;
  color: ${({ theme }) => theme.colors.white};
  align-item: center;
  display: inline-block !important;
  cursor: pointer;
  .subscribeText {
    font-family: ${({ theme }) => theme.fontFamilies.openSans};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.96px;
    text-transform: uppercase;
    padding-bottom: 3px;
    transition: color 0.2s;
    border-bottom: 1px solid
      ${({ theme }) => theme.components.footer.subscribe.hoverColor};
    &:hover {
      color: ${({ theme }) => theme.components.footer.subscribe.hoverColor};
    }
  }
  svg {
    color: ${({ theme }) => theme.components.footer.subscribe.hoverColor};
  }
  /* Switch to stacked layout at 1440px */
  @media (max-width: 90rem) {
    position: relative;
    text-align: center;
  }
`;

export const CatalogDownload = styled(Box)`
  position: relative;
  text-align: center;
  color: white;
`;

export const LogoWrapper = styled(Box)`
  display: flex;
  justify-content: center;
`;

export const DefaultCopyRightWrapper = styled(Box)`
  height: 5em;
  color: ${({ theme }) => theme.colors.white};
  opacity: 0.6;
  font-size: ${({ theme }) => theme.fontSizes.p3};
  padding-top: 1.75em;
  line-height: 1.67em;

  ${({ theme }) => css`
    @media (max-width: ${theme.components.footer.breakpoint}) {
      height: 4em;
      padding-top: 1em;
    }
  `}
`;

export const FooterIcon = styled(Icon)`
  height: 16px;
  margin-top: 2px;
`;

export const Tail = styled(Box)`
  ${({ theme }) => css`
    height: ${theme.components.footer.tail.height};
    background: ${theme.components.footer.tail.background};
  `}
  width: 100%;
`;

export const NewsLetterDesc = styled(Typography)`
  ${({ theme }) => css`
    ${theme.components.newsLetter.descFontSize &&
    css`
      font-size: ${theme.components.newsLetter.descFontSize};
    `}
    ${theme.components.newsLetter.descFontSize &&
    css`
      line-height: ${theme.components.newsLetter.descLineHeight};
    `}
  `}
`;
